import { createAction, props } from '@ngrx/store';

export const GET_EXTRA_COST_CONFIG_FILE_REQUEST =
  'GET_EXTRA_COST_CONFIG_FILE_REQUEST';
export const GET_EXTRA_COST_CONFIG_FILE_SUCCESS =
  'GET_EXTRA_COST_CONFIG_FILE_SUCCESS';
export const GET_EXTRA_COST_CONFIG_FILE_FAILURE =
  'GET_GET_EXTRA_COST_CONFIG_FILE_FAILURE';

export const getExtraCostConfigFileRequest = createAction(
  GET_EXTRA_COST_CONFIG_FILE_REQUEST
);
export const getExtraCostConfigFileSuccess = createAction(
  GET_EXTRA_COST_CONFIG_FILE_SUCCESS,
  props<{ csvResponse: string }>()
);
export const getExtraCostConfigFileFailure = createAction(
  GET_EXTRA_COST_CONFIG_FILE_FAILURE
);
